import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="text-center">
          <p className="text-sm">
            جميع الحقوق محفوظة - SOS Children's Villages International - قسم تكنولوجيا المعلومات والاتصالات
          </p>
          <p className="text-xs text-gray-400 mt-2">
            All rights reserved - SOS Children's Villages International - Information and Communications Technology Department
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

